import React, { useContext, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ViewSummaryText } from "../../features/summaryPrompt/ViewSummaryTextSlice";
import { updateSummaryText } from "../../features/summaryPrompt/updateSummaryTextSlice";
import { OK } from "../../constants/statusCode";
import Button from "../../components/form-components/Button";
// import { regenerateSummaryPrompt } from "../../features/summaryPrompt/regenerateSummaryPromptSlice";
import { resyncDocuments } from "../../features/user-document/resyncSlice";
import { getDocuments } from "../../features/user-document/documentListingSlice";
import { SocketContext } from "../../socket/socket";

export default function ViewSummayModal({
  title,
  isOpen,
  toggle,
  setSummaryText,
  perPage,
  page,
  summaryText,
  searchValue,
  documentData,
  subCategories,
  modalData,
}) {
  const dispatch = useDispatch();
  const socketContext = useContext(SocketContext);
  let userData = JSON.parse(localStorage.getItem("_user"));
  const [toggleTypeOfSummaryTextView, setToggleTypeOfSummaryTextView] =
    useState(false);

  const { isLoading = false, isSummaryLoading = false } = useSelector(
    (state) => ({
      isLoading: state?.updateSummaryTextReducer?.isLoading,
      isSummaryLoading: state?.regenerateSummaryPromptReducer?.isLoading,
    })
  );
  const [isDocumentSyncing, setIsDocumentSyncing] = useState(false);

  useEffect(() => {
    const getSummaryText = async () => {
      const { payload } = await dispatch(
        ViewSummaryText({
          projectId: userData?.projects[0].uuid,
          documentId: documentData.uuid,
        })
      );
      if (payload.status === OK) {
         setSummaryText(
          payload?.data?.responseData?.summary !== "" &&
            payload?.data?.responseData?.summary !== null
            ? payload?.data?.responseData?.summary
            : "NO SUMMARY FOUND!"
        ); 
        /* const staticString =
          "Dyno Route is a route optimization app available on both iOS and Android.\n It allows users to navigate their optimized routes using different mapping services such as Google Maps, Apple Maps, and Waze. The app offers various features, including customizable settings, distance unit selection (Miles or Kilometers), choice of navigation app, and the ability to specify the type of vehicle for deliveries.\n\n Users can export reports of their routes and personalize their delivery experience according to their preferences.\n Dyno Route aims to save time, fuel, and money while promoting green efficiency with intelligent route planning."
        setSummaryText(staticString); */
      }
    };
    if (isOpen) {
      getSummaryText();
    }
  }, [isOpen]);

  useEffect(() => {
    const documentSuccessEvent = (res) => {
      if (modalData?.uuid === res.documentUUID) {
        setIsDocumentSyncing(res.is_synced === 2);
      }
    }

    if (socketContext?.socket) {
      socketContext.socket.off("success", documentSuccessEvent);
      socketContext.socket.on("success", documentSuccessEvent);
    }
    return () => {
      socketContext.socket?.off("success", documentSuccessEvent);
    }
  }, [socketContext, isDocumentSyncing]);

  const updateSummaryTextData = async () => {
    if (toggleTypeOfSummaryTextView) {
      await dispatch(
        updateSummaryText({
          projectId: userData?.projects[0].uuid,
          documentId: documentData.uuid,
          summaryData: summaryText,
        })
      );
      setToggleTypeOfSummaryTextView(false);
    } else {
      setToggleTypeOfSummaryTextView(true);
    }
  };

  const regenerateResponse = async () => {
    /* const { payload } = await dispatch(
      regenerateSummaryPrompt({
        projectId: userData?.projects[0].uuid,
        documentId: documentData.uuid,
      })
    ); */
    let uuidArray = [];
    if (documentData) {
      uuidArray.push(documentData.uuid);
    }
    setIsDocumentSyncing(true);
    const { payload } = await dispatch(
      resyncDocuments({
        values: uuidArray,
        project_uuid: userData?.projects[0].uuid,
      })
    );
    if (payload.status === OK) {
      dispatch(
        getDocuments({
          perPage: perPage,
          page: page,
          project_uuid: userData?.projects[0].uuid,
          search: searchValue,
          type:
            subCategories === "Archive"
              ? "archive"
              : subCategories === "Starred"
              ? "favourite"
              : "",
        })
      );
      /* toggleModal(); */
    }

    /*  if (payload.status === OK) {
      setSummaryText(
        payload?.data?.responseData?.summary !== "" &&
          payload?.data?.responseData?.summary !== null
          ? payload?.data?.responseData?.summary
          : "NO SUMMARY FOUND!"
      );
    } */
  };

  return (
    <div>
      <Modal
        className="add-document-popup summary-modal-scroll"
        show={isOpen}
        onHide={toggle}
        backdrop="static"
        // modalTransition={{ timeout: 2000 }}
        centered={true}
        dialogClassName="common-modal modal-dialog-scrollable"
      >
        <Modal.Header>
          <h3 className="modal-title" id="Add_OrganizationLabel">
            {title}
          </h3>
          <div className="ms-auto">
            <Button
              disabled={
                isDocumentSyncing ||
                documentData.is_synced === 0
              }
              className="btn btn-primary-md me-2"
              onClick={() => {
                regenerateResponse();
              }}
            >
              {isSummaryLoading || isDocumentSyncing ? (
                <i className="fa fa-spinner fa-spin"></i>
              ) : (
                "Regenerate"
              )}
            </Button>
            <button
              type="button"
              className="btn-close pt-3"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={toggle}
            ></button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="d-flex pb-1">
              <h3 className="pb-1 modal-title">Document Title:</h3>
              {/* <span
                className="ms-2 tooltip-button"
                // onClick={() => redirectToPreviewDocument(documentData?.uuid,documentData?.type,documentData?.extension)}
              >
                <img
                  className="edit-icn"
                  src={redirectImage}
                  alt=""
                  height={15}
                  width={15}
                />
                <div class="tooltip-div">View Source</div>
              </span> */}
            </div>
            <p className="pb-3">{documentData?.title}</p>
            <div className="d-flex pb-2 justify-content-between align-items-center">
              <div className="d-flex">
                <h3 className="modal-title">Summary:</h3>
                {/* <span
                  className={
                    summaryRegenerateButtonDisable ||
                    documentData.is_synced !== 1
                      ? "ms-2 pe-none"
                      : `ms-2 tooltip-button`
                  }
                  onClick={() => updateSummaryTextData()}
                >
                  {isLoading ? (
                    <i className="fa fa-spinner fa-spin"></i>
                  ) : toggleTypeOfSummaryTextView ? (
                    <img
                      className="edit-icn"
                      src={saveImage}
                      alt=""
                      height={18}
                      width={18}
                    />
                  ) : (
                    <img
                      className="edit-icn"
                      src={editImg}
                      alt=""
                      height={18}
                      width={18}
                    />
                  )}
                  <div class="tooltip-div">
                    {!toggleTypeOfSummaryTextView ? "Edit " : "Save "}Summary
                  </div>
                </span>{" "} */}
              </div>
            </div>
          </div>
          {toggleTypeOfSummaryTextView ? (
            <textarea
              className="form-control h-100"
              rows={10}
              cols={20}
              // maxLength={400}
              value={summaryText}
              onChange={(e) => setSummaryText(e.target.value)}
            />
          ) : (
            <span
              dangerouslySetInnerHTML={{
                __html: summaryText.replaceAll("\n", "<br/>").trim(),
              }}
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}
